import { intoObject } from '../main.js';

import type { FetchEnhancer } from '../main.js';

const TRACKING_UUID_REGEX = /(?:^|; *)babbeltrackinguuid=([\da-f]{32})(?:; *|$)/;
const TRACKING_UUID_HEADER = 'x-babbel-tracking-uuid';

/**
 * Resolves User identifier is missing in the request. (browser only)
 * Add any of X-Babbel-UUID, X-Babbel-Tracking-UUID, X-Device-UDID headers.
 */
export const trackingUuidEnhancer: FetchEnhancer = (fetch) => async (info, options) => {
  const request = new Request(info, options);

  const [, uuid] = document.cookie.match(TRACKING_UUID_REGEX) ?? [];

  if (uuid) {
    request.headers.set(TRACKING_UUID_HEADER, uuid);
  }

  return fetch(info, {
    ...options,
    headers: intoObject(request.headers),
  } as typeof options);
};
